var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[(true)?_c('HomeList'):_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }